import Apptimize from '@apptimize/apptimize-web-sdk'

type StringDictionary = Record<string, string>

const getApptimizeStringDictionary = (
  variableName: string,
  defaultValue: StringDictionary
): StringDictionary => {
  const override = window?.apptimizeStringDictionary?.[variableName]
  if (override && typeof override === 'object' && !Array.isArray(override)) {
    return override
  }
  return Apptimize.getStringDictionary(variableName, defaultValue)
}

export default getApptimizeStringDictionary
